'use strict';

/**
 * @fileoverview `@puffin-core/redaction` — the ONE value-pattern redactor (SECURITY-HARDENING-GEMS
 * Q-SG-23 / Q-SG-24): `redactSensitiveText`, `redactStack` (a stack trace's message head), the partial
 * masks `redactEmail` / `redactPhone`, and the one placeholder `REDACTED_VALUE`. Used by
 * `@puffin-core/logging` and `@puffin-core/logging-browser`.
 *
 * @module @puffin-core/redaction
 */

const { redactSensitiveText, REDACTED_VALUE } = require('./redactSensitiveText');
const { redactStack } = require('./redactStack');
const { redactEmail, redactPhone } = require('./masks');

module.exports = { redactSensitiveText, redactStack, redactEmail, redactPhone, REDACTED_VALUE };
